import ContentLoader from "react-content-loader";

const ContactLoader = (props: any) => {
  const { loading } = props;
  return (
    <>
      {loading ? (
        <>
          <ContentLoader
            style={{ backgroundColor: "#FFFFFF", marginBottom: "10px", borderRadius: "10px" }}
            // viewBox="0 0 0 0"
            height={96}
            width={props.width ? props.width : "100%"}
            {...props}
          >
            <rect x="80" y="68" rx="8" ry="8" width="50" height="12" />
            <circle y="8" cx="40" cy="50" r="25" />
            <rect x="80" y="44" rx="8" ry="8" width="100" height="14" />
            <rect x="80" y="17" rx="8" ry="8" width="150" height="18" />

            <rect x="26%" y="37" rx="8" ry="8" width="50" height="18" className="company" />
            <rect x="47%" y="37" rx="8" ry="8" width="50" height="18" className="personality" />
            <rect x="63%" y="37" rx="8" ry="8" width="20" height="18" className="totalOpen" />
            <rect x="69%" y="37" rx="8" ry="8" width="20" height="18" className="uniqueOpen" />
            <rect x="75%" y="37" rx="8" ry="8" width="20" height="18" className="totalClick" />
            <rect x="81%" y="37" rx="8" ry="8" width="20" height="18" className="uniqueClick" />
            <rect x="87%" y="37" rx="8" ry="8" width="40" height="18" className="campaignScore" />
            <rect x="94%" y="37" rx="8" ry="8" width="40" height="18" className="lifetimeScore" />
          </ContentLoader>
        </>
      ) : null}
    </>
  );
};
export default ContactLoader;
